/**
 * Sticky promo progress banner: updates message based on qualifying cart count.
 * Mirrors the free-gift rule from cart-free-gift-checkout.js (2+ non-gift units; bundles count as 2+).
 * Listens to cart:update and refreshes banner state.
 */
(function () {
  const CART_JS_URL = '/cart.js';
  const FALLBACK_VARIANT_ID = '45798700089498';
  // Keep in sync with cart-free-gift-checkout.js
  const BUNDLE_PRODUCT_IDS = [
    8683658903706,
    8644832886938,
    8644819976346,
    8644817813658,
    8644815519898,
    8644782260378,
    8644765843610,
    8644756734106,
    8644738613402,
    8644702699674,
  ];
  const DISMISSED_KEY = 'promo-progress-banner-dismissed';

  /**
   * Compute qualifying (non-gift) quantity for the promo. Same logic as cart-free-gift-checkout.js.
   * @param {Object} cart
   * @param {string} giftVariantId
   * @returns {number}
   */
  function getQualifyingQuantity(cart, giftVariantId) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === String(giftVariantId)) continue;
      var qty = Number(item.quantity) || 0;
      var productId = Number(item.product_id || item.productId);
      var isBundle = !isNaN(productId) && BUNDLE_PRODUCT_IDS.indexOf(productId) !== -1;
      if (isBundle && qty > 0) {
        count += Math.max(2, qty);
      } else {
        count += qty;
      }
    }
    return count;
  }

  function getBanner() {
    return document.querySelector('[data-promo-banner]');
  }

  function isDismissed() {
    try {
      return sessionStorage.getItem(DISMISSED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed(value) {
    try {
      if (value) {
        sessionStorage.setItem(DISMISSED_KEY, '1');
      } else {
        sessionStorage.removeItem(DISMISSED_KEY);
      }
    } catch (e) {}
  }

  function updateBanner(banner, messageIndex, text) {
    var textEl = banner.querySelector('[data-promo-banner-text]');
    if (textEl) textEl.textContent = text;
    banner.setAttribute('data-state', messageIndex === 2 ? 'success' : messageIndex === 1 ? 'progress' : 'default');
    banner.removeAttribute('hidden');
    banner.setAttribute('data-visible', 'true');
  }

  function hideBanner(banner) {
    banner.setAttribute('hidden', '');
    banner.removeAttribute('data-visible');
  }

  function refreshBanner() {
    var banner = getBanner();
    if (!banner) return;
    if (isDismissed()) {
      hideBanner(banner);
      return;
    }
    var variantId = (banner.getAttribute('data-free-gift-variant-id') || '').trim() || FALLBACK_VARIANT_ID;
    var msg0 = banner.getAttribute('data-message-0') || '';
    var msg1 = banner.getAttribute('data-message-1') || '';
    var msg2 = banner.getAttribute('data-message-2') || '';

    fetch(CART_JS_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = getQualifyingQuantity(cart, variantId);
        var messageIndex = q >= 2 ? 2 : q === 1 ? 1 : 0;
        var text = messageIndex === 2 ? msg2 : messageIndex === 1 ? msg1 : msg0;
        updateBanner(banner, messageIndex, text);
      })
      .catch(function () {
        hideBanner(banner);
      });
  }

  function init() {
    var banner = getBanner();
    if (!banner) return;

    var dismissBtn = banner.querySelector('[data-promo-banner-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        setDismissed(true);
        hideBanner(banner);
      });
    }

    document.addEventListener('cart:update', function () {
      refreshBanner();
    }, false);

    refreshBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
